import React from 'react';
import { HomePage } from './pages/Home/HomePage';

const App: React.FC = () => <HomePage />;

export default App;
